__webpack_require__.p = "/prichan-calculator/";